import { api } from './api';
import { DocumentNode } from '../types/documents';
import { documentStatusService, DocumentStatusResponse } from './documentStatusService';

export interface IndexingStatus {
  documentId: string;
  isIndexed: boolean;
  indexedForSearch: boolean;
  indexedWorkspaceIds: string[];
}

export interface IndexingResponse {
  message: string;
}

export interface SearchRequest {
  query: string;
  maxResults: number;
}

class IndexingService {
  private baseUrl = '/index';

  /**
   * Pesquisa documentos no índice semântico
   */
  async searchDocuments(query: string, maxResults: number = 100): Promise<any> {
    try {
      const response = await api.post(`${this.baseUrl}/search`, {
        query,
        maxResults
      });
      
      return response.data;
    } catch (error) {
      console.error('Erro na pesquisa:', error);
      throw new Error(`Erro ao pesquisar documentos: ${error}`);
    }
  }

  /**
   * Indexa um documento no semântico usando indexação semântica
   */
  async indexDocumentSemantic(documentId: string): Promise<IndexingResponse> {
    try {
      const response = await api.post(`${this.baseUrl}/documents/${documentId}`, { documentId });
      
      return { message: "Documento adicionado a busca global com sucesso" };
    } catch (error) {
      console.error('Erro na indexação semântica:', error);
      throw new Error(`Erro ao indexar documento: ${error}`);
    }
  }

  /**
   * Atualiza um documento no índice do semântico
   */
  async updateDocumentInIndex(documentId: string): Promise<IndexingResponse> {
    try {
      const response = await api.put(`${this.baseUrl}/documents/${documentId}`, { documentId });
      
      return { message: "Documento atualizado no índice com sucesso" };
    } catch (error) {
      console.error('Erro na atualização:', error);
      throw new Error(`Erro ao atualizar documento: ${error}`);
    }
  }

  /**
   * Remove um documento do índice do semântico
   */
  async removeDocumentFromIndex(documentId: string): Promise<IndexingResponse> {
    try {
      const response = await api.delete(`${this.baseUrl}/documents/${documentId}`);
      
      return { message: "Documento removido do índice com sucesso" };
    } catch (error) {
      console.error('Erro na remoção:', error);
      throw new Error(`Erro ao remover documento: ${error}`);
    }
  }

  /**
   * Força commit das mudanças pendentes no índice
   */
  async commitIndexChanges(): Promise<void> {
    try {
      await api.post(`${this.baseUrl}/commit`);
    } catch (error) {
      console.error('Erro ao forçar commit do índice:', error);
      throw new Error(`Erro ao forçar commit do índice: ${error}`);
    }
  }

  /**
   * Verifica se um documento está indexado no semântico
   */
  async isDocumentIndexed(documentId: string): Promise<IndexingStatus> {
    try {
      // Usar o novo serviço de status unificado
      const status = await documentStatusService.getDocumentStatus(documentId);
      
      return {
        documentId,
        isIndexed: status.indexedForSearch || status.indexedWorkspaceIds.length > 0,
        indexedForSearch: status.indexedForSearch,
        indexedWorkspaceIds: status.indexedWorkspaceIds
      };
    } catch (error) {
      console.error('Erro ao verificar status:', error);
      return {
        documentId,
        isIndexed: false,
        indexedForSearch: false,
        indexedWorkspaceIds: []
      };
    }
  }
}

export const indexingService = new IndexingService(); 